import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  masterContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  noteContainer: {
    width: '45%',
    backgroundColor: 'rgba(0,158,226,.1)',
    borderRadius: '1em',
    marginTop: '1em',
    padding: '1em',
  },
  header: {
    display: 'flex',
    paddingBottom: 7,
    marginBottom: 7,
    justifyContent: 'flex-end',
    cursor: 'pointer',
    margin: '1em',
    flexDirection: 'row',
    fontSize: '13px',
    '& span': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  headerMaster: {
    display: 'flex',
    paddingBottom: 7,
    marginBottom: 7,
    justifyContent: 'space-between',
    cursor: 'pointer',
    margin: '0 0 1em 0',
    '& span': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  noteContent: {
    fontSize: '13px',
    fontWeight: '500',
    lineHeight: '20px',
    letterSpacing: '0px',
    textAlign: 'right',
    margin: '1em',
  },
  fileList: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
}))

export default useStyles
